import "core-js/modules/es.array.push.js";
import { ElMessage } from "element-plus";
import api from "@/api";
export default {
  name: "MaterialCard",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  computed: {
    coverImg() {
      // if (this.data) {
      //   for (let img of this.data.medias) {
      //     if (img.mediaType == 'IMG') {
      //       return img.url;
      //     }
      //   }
      // }
      if (this.data?.coverImage) {
        return this.data?.coverImage;
      }
      return 'https://cdn.waityou.online/86fc8768-5d24-f583-88b0-9511b6f86a12.png';
    }
  },
  data() {
    return {
      tagColors: ['#FF0000', '#FFA500', '#FFD700', '#008000', '#00BFFF', '#4169E1', '#800080', '#FF69B4', '#00FF00', '#30D5C8'],
      imgHeight: 0
    };
  },
  methods: {
    download() {
      api.downloadAsZipFile(this.data.id).then(ret => {
        window.open(ret);
      });
    },
    toEdit() {
      this.$router.push('/editor/' + this.data.id);
    },
    copy() {
      try {
        navigator.clipboard.writeText(this.data.title + "\n" + this.extractPlainText(this.data.content));
        ElMessage.success('复制成功');
      } catch (err) {
        ElMessage.error('复制失败');
      }
    },
    extractPlainText(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    toDetail() {
      window.open('/material/detail/' + this.data.id);
    },
    init() {
      // this.imgHeight = this.$refs.coverImg.height;
    }
  },
  mounted() {
    this.init();
  }
};